import { render } from "./BusinessClassificationEdit.vue?vue&type=template&id=71219042"
import script from "./BusinessClassificationEdit.vue?vue&type=script&lang=js"
export * from "./BusinessClassificationEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__